export default __webpack_public_path__ + "static/media/token-metrics-3.6d4ff361.svg";